<template>
  <el-button type="success" size="mini" @click="onSubmit" title="Test Newsletter">
    Test
  </el-button>
</template>

<script>
export default {
  props: {
    newsletterId: String,
  },

  methods: {
    async onSubmit() {
      try {
        await this.$confirm('This will send out one test email to the author of this newsletter.', 'Confirm Test', {
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Confirm Send',
          type: 'warning'
        })
      } catch(err) {
        return false
      }

      try {
        var { data } = await this.$http.post(`/newsletters/${ this.newsletterId }/test`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      }

      this.$emit('update')
      this.$message.success('Test newsletter has been sent.')
    },
  },
}
</script>
